import Template from "backbone/projects/templates/add_project_button.js.hamlc"

export default class AddProjectButton extends Backbone.View

  initialize: ->
    @parentViewState = @options.parentViewState
    @listenTo(@parentViewState, "change", @render)

  render: ->
    @$el.html(Template(parentViewState: @parentViewState))



// WEBPACK FOOTER //
// ./app/javascript/backbone/projects/views/add_project_button.js.coffee